import { HeroLines } from "@/components/site/Motion";
import { ContactButton } from "@/components/site/ContactButton";
import { CoachingScope } from "@/components/site/CoachingScope";

export const PageHero = ({ eyebrow, lines, text, badge, testId, children }) => (
  <section className="ink-wash grain relative overflow-hidden pb-20 pt-36 md:pb-28 md:pt-44" data-testid={testId}>
    <img src="/panchmaya-mark-640.webp" width="640" height="640" alt="" className="spin-slow pointer-events-none absolute -right-24 top-24 h-auto w-[340px] rounded-full opacity-[0.12] md:-right-16 md:w-[520px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="flex flex-wrap items-center justify-center gap-4 sm:justify-start">
        <p className="eyebrow">{eyebrow}</p>
      </div>
      <HeroLines testId={`${testId}-title`} lines={lines}
        className="font-display mt-6 max-w-4xl text-center text-[clamp(2.5rem,10.5vw,3.25rem)] font-medium leading-[1.02] tracking-tight text-[#221e1b] sm:text-left sm:text-[4.5rem] lg:text-[6rem]" />
      {badge && <div className="mt-7 flex justify-center sm:justify-start"><p className="max-w-2xl rounded-2xl border border-[#d5bc8e]/70 bg-[#fffaf3]/85 px-4 py-2.5 text-center text-sm font-medium leading-relaxed text-[#7a5615] sm:rounded-full sm:text-left">{badge}</p></div>}
      <p className="mt-8 max-w-2xl text-[1.0625rem] leading-[1.75] text-[#5d544c] sm:text-lg lg:text-xl">{text}</p>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-4 sm:justify-start">
        {children || <ContactButton testId={`${testId}-contact-btn`} />}
      </div>
      <CoachingScope />
    </div>
  </section>
);
